import React from 'react';
import { Alert } from 'antd';
import './style.less';

const HotelInfoDisplay = ({ hotelInfo, suggestedCheckIn, suggestedCheckOut, hotelOptions = [], onEditHotel }) => {
    // 判断是否有建议日期
    const hasConfirmedTasks = suggestedCheckIn !== undefined;

    // 根据need字段获取标签文本
    const getNeedLabel = needValue => {
        if (needValue === 1) return '（会务组安排）';
        if (needValue === 2) return '（自费）';
        return '';
    };

    // 判断need字段是否为空（undefined、null或false）
    const isNeedEmpty = needValue => {
        return needValue === undefined || needValue === null || needValue === false;
    };

    // 判断住宿信息是否有实质性内容
    const hasHotelContent = info => {
        if (!info || !info.hotel) {
            return false;
        }
        const hotel = info.hotel;
        // 检查是否有任何字段填写
        return !!(hotel.checkin_date || hotel.checkout_date || hotel.hotel_id || hotel.hotel_room_type_id);
    };

    // 根据酒店ID获取酒店名称
    const getHotelName = hotelId => {
        if (!hotelId) return null;
        const hotel = hotelOptions.find(h => h.value === hotelId);
        return hotel?.label || null;
    };

    // 根据酒店ID和房型ID获取房型名称
    const getRoomTypeName = (hotelId, roomTypeId) => {
        if (!hotelId || !roomTypeId) return null;
        const hotel = hotelOptions.find(h => h.value === hotelId);
        if (hotel && hotel.roomTypes) {
            const roomType = hotel.roomTypes.find(rt => rt.id === roomTypeId);
            return roomType?.roomType || null;
        }
        return null;
    };

    return (
        <div className="hotel-info-cell">
            {/* 系统建议日期 */}
            <div className="suggested-date-row">
                <span className="system-tag">系统</span>
                <div>
                    {hasConfirmedTasks ? (
                        <>
                            <span className="date-text">建议入住日期 {suggestedCheckIn}</span>
                            <span className="date-text">建议退房日期 {suggestedCheckOut || '暂无'}</span>
                        </>
                    ) : (
                        <>
                            <span className="date-text">
                                建议入住日期 <span className="gray">暂无</span>
                            </span>
                            <span className="date-text">
                                建议退房日期 <span className="gray">暂无</span>
                            </span>
                        </>
                    )}
                </div>
            </div>

            {/* 住宿信息区域 */}
            {hotelInfo?.need === 0 ? (
                // 无需住宿
                <div className="info-section hotel-section no-need-single">
                    <div className="section-header">住宿</div>
                    <div className="section-content">
                        <div className="no-need-content">
                            <i className="bi bi-slash-circle"></i>
                            <span>无需住宿</span>
                        </div>
                        {/* 备注信息（无需住宿时也展示，置于“无需住宿”下方，Alert样式，与内容态一致） */}
                        {hotelInfo?.remarks && (
                            <div className="remark-alert-wrapper">
                                <Alert title={hotelInfo.remarks} type="warning" showIcon={false} className="remark-alert" />
                            </div>
                        )}
                        <div className="time-and-actions">
                            {/* 最后更新时间（无需住宿时也展示） */}
                            {hotelInfo?.updated_at && (
                                <div className="last-update-time">
                                    <i className="bi bi-clock"></i>
                                    <span>最后更新时间 {hotelInfo.updated_at}</span>
                                </div>
                            )}
                            {/* 编辑按钮 */}
                            <div className="journey-actions">
                                <div className="action-item" onClick={onEditHotel}>
                                    <i className="bi bi-pencil"></i>
                                    <span>编辑</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : !isNeedEmpty(hotelInfo?.need) && hasHotelContent(hotelInfo) ? (
                // 已填写状态
                <div className="info-section hotel-section">
                    <div className="section-header">住宿{getNeedLabel(hotelInfo.need)}</div>
                    <div className="section-content">
                        {/* 住宿详情 */}
                        <div className="hotel-item">
                            <i className="bi bi-lamp hotel-icon"></i>
                            <div className="hotel-details">
                                {hotelInfo.hotel?.checkin_date && <div className="hotel-text">入住日期：{hotelInfo.hotel.checkin_date}</div>}
                                {hotelInfo.hotel?.checkout_date && <div className="hotel-text">退房日期：{hotelInfo.hotel.checkout_date}</div>}
                                {hotelInfo.hotel?.hotel_id && <div className="hotel-text">酒店：{getHotelName(hotelInfo.hotel.hotel_id) || '暂无'}</div>}
                                {hotelInfo.hotel?.hotel_room_type_id && <div className="hotel-text">房型：{getRoomTypeName(hotelInfo.hotel.hotel_id, hotelInfo.hotel.hotel_room_type_id) || '暂无'}</div>}
                                {hotelInfo.hotel?.room_no && <div className="hotel-text">房间号：{hotelInfo.hotel.room_no}</div>}
                            </div>
                        </div>

                        {/* 备注信息 */}
                        {hotelInfo.remarks && (
                            <div className="remark-alert-wrapper">
                                <Alert title={hotelInfo.remarks} type="warning" showIcon={false} className="remark-alert" />
                            </div>
                        )}

                        <div className="time-and-actions">
                            {/* 最后更新时间 */}
                            {hotelInfo.updated_at && (
                                <div className="last-update-time">
                                    <i className="bi bi-clock"></i>
                                    <span>最后更新时间 {hotelInfo.updated_at}</span>
                                </div>
                            )}

                            {/* 操作按钮 */}
                            <div className="journey-actions">
                                <div className="action-item" onClick={onEditHotel}>
                                    <i className="bi bi-pencil"></i>
                                    <span>编辑</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // 空状态：暂未填写
                <div className="info-section hotel-section empty">
                    <div className="section-header">{isNeedEmpty(hotelInfo?.need) ? '住宿' : `住宿${getNeedLabel(hotelInfo.need)}`}</div>
                    <div className="section-content">
                        <div className="empty-block">
                            <div className="empty-content">暂未填写</div>
                            {/* 备注信息（空状态也展示，置于“暂未填写”下方，Alert样式，与内容态一致） */}
                            {hotelInfo?.remarks && (
                                <div className="remark-alert-wrapper">
                                    <Alert title={hotelInfo.remarks} type="warning" showIcon={false} className="remark-alert" />
                                </div>
                            )}
                            <div className="time-and-actions">
                                {/* 最后更新时间（空状态也展示） */}
                                {hotelInfo?.updated_at && (
                                    <div className="last-update-time">
                                        <i className="bi bi-clock"></i>
                                        <span>最后更新时间 {hotelInfo.updated_at}</span>
                                    </div>
                                )}
                                {/* 编辑按钮 - 空状态也显示 */}
                                <div className="journey-actions">
                                    <div className="action-item" onClick={onEditHotel}>
                                        <i className="bi bi-pencil"></i>
                                        <span>编辑</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HotelInfoDisplay;
